import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useRouter } from 'next/router';

import { useAuthentication } from 'hooks/useAuthentication';

import { useRedirectToSso } from 'templates/Schedule/shared/hooks/useRedirectToSso';

export const ProtectedRoute: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { tokenIsValid, userData } = useAuthentication();
  const {
    query: { id },
    push,
    isReady,
  } = useRouter();
  const { getSsoUrl } = useRedirectToSso();

  useEffect(() => {
    const user = userData();

    if (user) {
      const userName = `${user?.name} ${user?.surname}`;

      datadogRum.setUser({
        name: userName,
        email: user?.email,
      });
    }
  }, [userData]);

  useEffect(() => {
    if (tokenIsValid() || !isReady) return;

    if (Array.isArray(id)) {
      push(getSsoUrl(id[0]));

      return;
    }

    push(getSsoUrl(id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);

  if (!tokenIsValid()) return null;

  return <>{children}</>;
};
